// src/admin/utils/initAdmin.js
export const initializeFirstAdmin = () => {
  // Check if we already have admin permissions set up
  const existingPermissions = localStorage.getItem('adminPermissions');
  
  if (!existingPermissions) {
    // Create initial super admin permissions for the hardcoded admin
    const superAdminPermissions = {
      'super_admin_1': {
        canManageUsers: true,
        canManageContent: true,
        canManageSettings: true,
        canCreateAdmins: true,
        canAssignPermissions: true
      }
    };
    
    localStorage.setItem('adminPermissions', JSON.stringify(superAdminPermissions));
  }
};

// Function to check if user is super admin
export const isSuperAdmin = (userId) => {
  const permissions = localStorage.getItem('adminPermissions');
  if (!permissions) return false;
  
  try {
    const adminPerms = JSON.parse(permissions);
    const userPerms = adminPerms[userId];
    return userPerms && userPerms.canCreateAdmins;
  } catch {
    return false;
  }
};

// Function to get admin permissions for a user
export const getAdminPermissions = (userId) => {
  const permissions = localStorage.getItem('adminPermissions');
  if (!permissions) return null;
  
  try {
    const adminPerms = JSON.parse(permissions);
    return adminPerms[userId];
  } catch {
    return null;
  }
};